/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import * as React from "react";
import { Grid, GridColumn } from "semantic-ui-react";
import "./project-show.css"
import LabeledValue from "../../../components/labeled-value/labeled-value";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { SoilImprovementProject } from "../../../stores/project/project";
import { getDesc, getLabel } from "../../../reflection/reflection";

export default function SoilImprovementShow({ project }: { project: SoilImprovementProject }): JSX.Element {
    return (<div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledValue
                        label={getLabel(project, "fullType")}
                        value={project.type}
                    />
                    <LabeledValue
                        label={getLabel(project, "municipalityName")}
                        desc={getDesc(project, "municipalityName")}
                        value={project.municipalityName}/>
                    <LabeledValue
                        label={getLabel(project, "place")}
                        desc={getDesc(project, "place")}
                        value={project.place}/>
                    <LabeledValue
                        label={getLabel(project, "status")}
                        desc={getDesc(project, "status")}
                        value={project.status}/>
                    <LabeledValue
                        label={getLabel(project, "ebageNr")}
                        desc={getDesc(project, "ebageNr")}
                        value={project.ebageNr}/>
                    <LabeledValue
                        label={getLabel(project, "enactmentDateDisplayText")}
                        desc={getDesc(project, "enactmentDateDisplayText")}
                        value={project.enactmentDateDisplayText}/>
                    <LabeledValue
                        label={getLabel(project, "approvedCreationArea")}
                        desc={getDesc(project, "approvedCreationArea")}
                        value={project.approvedCreationArea?.toLocaleString()}/>
                    <LabeledValue
                        label={getLabel(project, "creationGoalSource")}
                        value={project.creationGoalSource}/>
                    <LabeledValue
                        label={getLabel(project, "landOwnerFullName")}
                        desc={getDesc(project, "landOwnerFullName")}
                        value={project.landOwnerFullName}/>
                    <LabeledValue
                        label={getLabel(project, "cmiNumberRawi")}
                        desc={getDesc(project, "cmiNumberRawi")}
                        value={project.cmiNumberRawi}
                    />
                    <LabeledValue
                        label={getLabel(project, "constructionSupervisorFullName")}
                        desc={getDesc(project, "constructionSupervisorFullName")}
                        value={project.constructionSupervisorFullName}/>
                    <LabeledValue
                        label={getLabel(project, "requirementsSpecificationBBBStatus")}
                        desc={getDesc(project, "requirementsSpecificationBBBStatus")}
                        value={project.requirementsSpecificationBBBStatus}
                    />
                    <LabeledValue
                        label={getLabel(project, "requirementsSpecificationRequestSource")}
                        desc={getDesc(project, "requirementsSpecificationRequestSource")}
                        value={project.requirementsSpecificationRequestSource}
                    />
                    <LabeledValue
                        label={getLabel(project, "startConstructionMeetingStatus")}
                        desc={getDesc(project, "startConstructionMeetingStatus")}
                        value={project.startConstructionMeetingStatus}
                    />
                    <LabeledValue
                        label={getLabel(project, "startConstructionMeetingSource")}
                        desc={getDesc(project, "startConstructionMeetingSource")}
                        value={project.startConstructionMeetingSource}
                    />
                    <LabeledValue
                        label={getLabel(project, "geometrySource")}
                        desc={getDesc(project, "geometrySource")}
                        value={project.geometrySource}
                    />
                    <LabeledValue
                        label={getLabel(project, "geometrySourceDateDisplayText")}
                        desc={getDesc(project, "geometrySourceDateDisplayText")}
                        value={project.geometrySourceDateDisplayText}
                    />
                </GridColumn>
                <GridColumn>
                    <LabeledTextArea label={getLabel(project, "generalRemarks")}
                                     name="generalRemarks" defaultValue={project.generalRemarks}
                                     disabled={true}/>
                    <LabeledTextArea label={getLabel(project, "enactmentRemarks")}
                                     name="enactmentRemarks"
                                     defaultValue={project.enactmentRemarks} disabled={true}/>
                    <LabeledTextArea label={getLabel(project, "creationGoalRemarks")}
                                     name="creationGoalRemarks"
                                     defaultValue={project.creationGoalRemarks} disabled={true}/>
                </GridColumn>
            </Grid>
        </div>
    );
}
